/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIBarcodeType } from './APIBarcodeType';
import {
    APIBarcodeTypeFromJSON,
    APIBarcodeTypeFromJSONTyped,
    APIBarcodeTypeToJSON,
} from './APIBarcodeType';

/**
 * 
 * @export
 * @interface APIPaginatedBarcodeTypeList
 */
export interface APIPaginatedBarcodeTypeList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedBarcodeTypeList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedBarcodeTypeList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedBarcodeTypeList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIBarcodeType>}
     * @memberof APIPaginatedBarcodeTypeList
     */
    results: Array<APIBarcodeType>;
}

/**
 * Check if a given object implements the APIPaginatedBarcodeTypeList interface.
 */
export function instanceOfAPIPaginatedBarcodeTypeList(value: object): value is APIPaginatedBarcodeTypeList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedBarcodeTypeListFromJSON(json: any): APIPaginatedBarcodeTypeList {
    return APIPaginatedBarcodeTypeListFromJSONTyped(json, false);
}

export function APIPaginatedBarcodeTypeListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedBarcodeTypeList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIBarcodeTypeFromJSON)),
    };
}

export function APIPaginatedBarcodeTypeListToJSON(value?: APIPaginatedBarcodeTypeList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIBarcodeTypeToJSON)),
    };
}

